import { render } from "./restyle_header.vue?vue&type=template&id=1b4f3cb9&scoped=true"
import script from "./restyle_header.vue?vue&type=script&lang=js"
export * from "./restyle_header.vue?vue&type=script&lang=js"

import "./restyle_header.vue?vue&type=style&index=0&id=1b4f3cb9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4f3cb9"]])

export default __exports__